import MiniAssetPicker from "./MiniAssetPicker";
import ElementsRow from "./ElementsRow";
import { elementsMediaType } from "./constants";

// `sticky left-0` keeps the label in view while the row scrolls horizontally;
// `self-start` stops the sticky element stretching to the row's full height.
const InputLabel = ({ input, className = "" }) => (
  <span
    className={`sticky left-0 z-10 self-start text-[10px] text-secondary-foreground/70 px-0.5 select-none truncate ${className}`}>
    {input.name}
    {input.required && <span className="text-destructive-foreground">*</span>}
  </span>
);

export default function VisualInputsRow({
  inputs,
  modelData,
  resolveAssetById,
  onChange,
  onAssetDrop,
  onPreview,
}) {
  return (
    // `min-w-0` lets this row shrink below its content width instead of
    // setting a floor on the panel's width — with `overflow-x-auto` it
    // scrolls once the panel is narrower than the row's content.
    <div className="w-full relative">
      <div
        id="VisualInputsRow"
        className="flex items-start gap-3 p-3 pr-20 pb-2 overflow-x-auto min-w-0">
        {inputs.map((input) => {
          if (
            input.type === "image" ||
            input.type === "video" ||
            input.type === "audio"
          ) {
            return (
              <div
                key={input.prop}
                id={`VisualInputsRow__input--${input.prop}`}
                className="flex flex-col gap-1"
                title={input.name}>
                <InputLabel input={input} className="max-w-20" />
                <div
                  id={`VisualInputsRow__picker--${input.prop}`}
                  className="group relative">
                  <MiniAssetPicker
                    asset={modelData?.[input.prop]}
                    mediaType={input.type}
                    resolveAssetById={resolveAssetById}
                    onAssetDrop={(assets) => onAssetDrop(assets, input)}
                    onChange={(value) => onChange(input.prop, value)}
                    onPreview={onPreview}
                  />
                </div>
              </div>
            );
          }
          const values = Array.isArray(modelData?.[input.prop])
            ? modelData[input.prop]
            : [];
          return (
            <div
              key={input.prop}
              id={`VisualInputsRow__elements--${input.prop}`}
              className="flex flex-col gap-1"
              title={input.name}>
              <InputLabel input={input} />
              <ElementsRow
                prop={input.prop}
                values={values}
                mediaType={elementsMediaType(input.type)}
                max={input.max || 8}
                onChange={(next) => onChange(input.prop, next)}
                onPreview={onPreview}
                resolveAssetById={resolveAssetById}
                onAssetDrop={(assets) => onAssetDrop(assets, input)}
              />
            </div>
          );
        })}
      </div>
      <div className="h-full w-20 bg-gradient-to-l from-card absolute right-0 top-0 pointer-events-none" />
    </div>
  );
}
